// Libs
import $ from 'jquery';
import 'jquery-ui/dist/jquery-ui';

import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import {
  formatUserStatus,
  formatFullName,
  formatGeneric,
  formatRowMenu
} from '../usersGridFormatter';
import classNames from 'classnames';

// Components
import TeamListTooltipContainer from '../../teams/teamListTooltip';
import RolesTooltipContainer from '../../roles/rolesTooltip';
import SearchBox from '../../portal/searchBox';
import UsersTableToolbar from '../usersTableToolbar';
import UsersGridFilter from '../usersGridFilter';
import DateTimeformatter from '../../../services/ui/datetime/dateTimeFormatter';
import DateFilter from '../dateFilter';

// Styles
import styles from './style.scss';

@inject(
  'translationsStore',
  'oidcStore',
  'usersStore',
  'usersGridStore',
  'teamsStore',
  'rolesStore',
  'systemLocalesStore'
)
@observer
export default class UsersGrid extends Component {
  constructor(props) {
    super(props);

    this.state = {
      columnWidths: [0, 75, 130, 100, 175, 100, 100, 100, 100, 100, 145, 145]
    };

    this.t = this.props.translationsStore.translate;
    this.csvEnabled = 'enabled';

    this.keywords = {
      searchLibrary: this.t('SEARCH_USER'),
      clear: this.t('CLEAR')
    };

    this.isfiltersApplied = false;
  }

  exportCSVBtn = (onClick) => (
    <span onClick={onClick} className={`export-csv-button ${this.csvEnabled}`}>
      <span className="export-icon"></span>
      {' ' + this.t('EXPORT')}
    </span>
  );

  toolBar = (props) => <UsersTableToolbar {...props} />;

  onPageChange = (page, sizePerPage) => {
    if (this.props.usersGridStore.selectedPage != page) {
      this.props.usersGridStore.selectedRows = [];
    }
    this.props.usersGridStore.selectedPage = page;
  };

  onSizePerPageList = (sizePerPage) => {
    if (this.props.usersGridStore.rowsPerPage != sizePerPage) {
      this.props.usersGridStore.selectedRows = [];
    }
    this.props.usersGridStore.rowsPerPage = sizePerPage;
  };

  afterFilter = (searchText, result) => {
    this.props.usersGridStore.filteredUsers = result;
    this.csvEnabled = result.length === 0 ? 'disabled' : 'enabled';
  };

  afterSearch = (searchText, result) => {
    const { searchData, selectedRows } = this.props.usersGridStore;

    if (searchText !== null) {
      this.props.usersGridStore.searchData = searchText;

      if (searchText !== searchData && selectedRows.length > 0) {
        this.props.usersGridStore.selectedRows = [];
      }
    }
    this.props.usersGridStore.filteredUsers = result;
    this.csvEnabled = result.length === 0 ? 'disabled' : 'enabled';
  };

  handleChangeUserName = (e) =>
    this.props.usersStore.setUserName(e.target.value);
  handleChangeFirstName = (e) =>
    this.props.usersStore.setFirstName(e.target.value);
  handleChangeLastName = (e) =>
    this.props.usersStore.setLastName(e.target.value);
  handleChangeEmail = (e) => this.props.usersStore.setEmail(e.target.value);
  handleChangePassword = (e) =>
    this.props.usersStore.setPassword(e.target.value);

  formatTeams = (teamIds, rowData, o, index) => (
    <div className="general-table-column ellipsis">
      <TeamListTooltipContainer teamIds={teamIds} itemId={'team-' + index} />
    </div>
  );

  formatTeamIds = (teamIds) => {
    return teamIds;
  };

  formatRoles = (roleIds, rowData, o, index) => (
    <div className="general-table-column ellipsis">
      <RolesTooltipContainer roleIds={roleIds} itemId={'role-' + index} />
    </div>
  );

  formatRoleIds = (roleIds) => {
    return roleIds;
  };

  formatDate = (dateTimeText) => {
    let date;
    const year = new Date(dateTimeText).getFullYear();

    if (!dateTimeText || year === 1) {
      date = this.t('NONE');
    } else {
      date = new DateTimeformatter().toLocaleString(dateTimeText);
    }
    return date;
  };

  formatDateHtml = (dateTimeText, rowData, enumObject, index) => {
    const date = this.formatDate(dateTimeText);
    return (
      <div className="general-table-column" title={date}>
        {date}
      </div>
    );
  };

  formatDateCsv = (dateTimeText, rowData) => this.formatDate(dateTimeText);

  handleTableComplete = () => {
    if (!this.isfiltersApplied) {
      if (this.isFilterUserStatusExist()) {
        this.refs.userStatusCol.customFilter.filterGrid(
          this.props.usersGridStore.filteredUserStatus
        );
      }

      if (this.isfilterTeamsExist()) {
        this.refs.teamsCol.customFilter.filterGrid(
          this.props.usersGridStore.filterTeams
        );
      }

      if (this.isFilterRolesExist()) {
        this.refs.rolesCol.customFilter.filterGrid(
          this.props.usersGridStore.filterRoles
        );
      }

      if (this.isFilterLastLoginExist()) {
        this.refs.lastLoginDateCol.customFilter.filterGrid(
          this.props.usersGridStore.lastLoginOver
        );
      }

      if (this.isFilterCreationDateExist()) {
        this.refs.creationDateCol.customFilter.filterGrid(
          this.props.usersGridStore.creationDateOver
        );
      }

      this.isfiltersApplied = true;
    }
  };

  getTeamsFilterValue = (cell, row) => cell;

  teamsFilterHandler = (teamIds) => {
    this.props.usersGridStore.filterTeams = teamIds;
    this.props.usersGridStore.selectedRows = [];
  };

  isfilterTeamsExist = () =>
    this.props.usersGridStore.filterTeams &&
    this.props.usersGridStore.filterTeams.length > 0;

  formatTeamFullName = (team) => {
    var fullNameFormatted = team.fullName
      .substring(1)
      .replace(new RegExp('/', 'g'), ' > ');
    return fullNameFormatted;
  };

  createTeamFilter = (filterHandler) => (
    <UsersGridFilter
      ref="teamsFilter"
      header={this.t('FILTER_TEAMS')}
      handleFilter={filterHandler}
      afterGridFiltering={this.teamsFilterHandler}
      data={this.props.teamsStore.teams}
      selectedItemIds={this.props.usersGridStore.filterTeams}
      gridFiltered={this.isfilterTeamsExist()}
      filterId="userTeamsFilter"
      searchPlaceHolderTitle={this.t('SEARCH_TEAMS')}
      formatAdditionalData={this.formatTeamFullName}
      submitLabel={this.t('FILTER')}
      rowHeight={55}
    />
  );

  getRolesFilterValue = (cell, row) => cell;

  rolesFilterHandler = (roleIds) => {
    this.props.usersGridStore.filterRoles = roleIds;
    this.props.usersGridStore.selectedRows = [];
  };

  isFilterRolesExist = () =>
    this.props.usersGridStore.filterRoles &&
    this.props.usersGridStore.filterRoles.length > 0;

  createRoleFilter = (filterHandler) => (
    <UsersGridFilter
      header={this.t('FILTER_ROLES')}
      handleFilter={filterHandler}
      afterGridFiltering={this.rolesFilterHandler}
      data={this.props.rolesStore.roles}
      selectedItemIds={this.props.usersGridStore.filterRoles}
      gridFiltered={this.isFilterRolesExist()}
      filterId="userRolesFilter"
      searchPlaceHolderTitle={this.t('SEARCH_ROLES')}
      submitLabel={this.t('FILTER')}
      rowHeight={32}
    />
  );

  getUserStatusFilterValue = (cell, row) => [cell];

  userStatusFilterHandler = (userStatusIds) => {
    this.props.usersGridStore.filteredUserStatus = userStatusIds;
    this.props.usersGridStore.selectedRows = [];
  };

  isFilterUserStatusExist = () =>
    this.props.usersGridStore.filteredUserStatus &&
    this.props.usersGridStore.filteredUserStatus.length > 0;

  createUserStatusFilter = (filterHandler) => (
    <UsersGridFilter
      header={this.t('FILTER_USER_STATUS')}
      dataCy="Filter_User_Status"
      handleFilter={filterHandler}
      afterGridFiltering={this.userStatusFilterHandler}
      data={[
        { id: true, name: this.t('ACTIVE_USERS') },
        { id: false, name: this.t('DISABLED_USERS') }
      ]}
      selectedItemIds={this.props.usersGridStore.filteredUserStatus}
      gridFiltered={this.isFilterUserStatusExist()}
      filterId="userStatusFilter"
      submitLabel={this.t('FILTER')}
      rowHeight={32}
      height={90}
      hideSearch={true}
    />
  );

  getLastLoginFilterValue = (cell, row) => cell;

  lastLoginFilterHandler = (lastLoginOver) => {
    this.props.usersGridStore.lastLoginOver = lastLoginOver;
    this.props.usersGridStore.selectedRows = [];
  };

  creationDateFilterHandler = (creationDateOver) => {
    this.props.usersGridStore.creationDateOver = creationDateOver;
    this.props.usersGridStore.selectedRows = [];
  };

  isFilterLastLoginExist = () =>
    this.props.usersGridStore.lastLoginOver ? true : false;

  createDateFilterOptions = () => {
    let options = [];
    options.push({ value: 1, text: this.t('OVER_1_MONTH') });
    options.push({ value: 6, text: this.t('OVER_6_MONTH') });
    options.push({ value: 12, text: this.t('OVER_12_MONTH') });
    return options;
  };

  createLastLoginFilter = (filterHandler) => (
    <DateFilter
      handleFilter={filterHandler}
      afterGridFiltering={this.lastLoginFilterHandler}
      selectedMonthNumber={this.props.usersGridStore.lastLoginOver}
      gridFiltered={this.isFilterLastLoginExist()}
      filterId="lastLoginFilter"
      selectableItems={this.createDateFilterOptions()}
      submitLabel={this.t('FILTER')}
    />
  );

  createCreationDateFilter = (filterHandler) => (
    <DateFilter
      handleFilter={filterHandler}
      afterGridFiltering={this.creationDateFilterHandler}
      selectedMonthNumber={this.props.usersGridStore.creationDateOver}
      gridFiltered={this.isFilterCreationDateExist()}
      filterId="creationDateFilter"
      selectableItems={this.createDateFilterOptions()}
      submitLabel={this.t('FILTER')}
    />
  );

  getCreationDateFilterValue = (cell, row) => cell;

  isFilterCreationDateExist = () =>
    this.props.usersGridStore.creationDateOver ? true : false;

  formatCSV = (data) => '\'' + String(data).trim().replaceAll('"', '""');

  formatCSVTeamName = (data) =>
    '\'' +
    this.props.teamsStore
      .getUserTeamNames(data)
      .toLocaleString()
      .replaceAll('"', '""');

  formatCSVRoleName = (data) =>
    '\'' +
    this.props.rolesStore
      .getUserRoleNames(data)
      .toLocaleString()
      .replaceAll('"', '""');

  onSelectRow = (row, isSelected, event, rowIndex) => {
    const { selectedRows } = this.props.usersGridStore;
    this.props.usersGridStore.selectedRows = isSelected
      ? [...selectedRows, row]
      : selectedRows.filter((r) => r.id !== row.id);
  };

  onSelectAll = (isSelected, rows) => {
    this.props.usersGridStore.selectedRows = isSelected ? rows : [];
    return isSelected && rows;
  };

  componentDidMount() {
    this.props.usersGridStore.selectedRows = [];
    // prepare resizable columns
    for (let index = 1; index < 13; index ++) {
      if ($(`.react-bs-container-header thead th:eq(${index})`).length === 0)
        break; // break if cant find any more columns

        $(`.react-bs-container-header thead th:eq(${index})`).resizable({
          minWidth: 50,
          handles: 'e',
          resize: (__event, ui) => {
            const newColumnWidths = [...this.state.columnWidths];
            newColumnWidths[index] = ui.size.width;
            this.setState({ columnWidths: newColumnWidths });
          }
        });
    }
  }

  sortLastLoginDate = (a, b, order) =>
    this.sortDate(a.lastLoginDate, b.lastLoginDate, order);

  sortCreationDate = (a, b, order) =>
    this.sortDate(a.creationDate, b.creationDate, order);

  sortDate = (a, b, order) => {
    var aDate = new Date(a);
    var bDate = new Date(b);
    return order === 'desc' ? bDate - aDate : aDate - bDate;
  };

  render() {
    if (
      this.props.usersStore.users === undefined ||
      this.props.teamsStore.teams === undefined ||
      this.props.rolesStore.roles === undefined ||
      this.props.systemLocalesStore.languages === undefined
    ) {
      return null;
    }

    let table = null;

    const { selectedPage, rowsPerPage, selectedRows } =
      this.props.usersGridStore;

    const tableOptions = {
      page: selectedPage,
      sizePerPage: rowsPerPage,
      sortIndicator: true,
      toolBar: this.toolBar,
      afterColumnFilter: this.afterFilter,
      noDataText: this.t('NO_DATA_TO_DISPLAY'),
      exportCSVBtn: this.exportCSVBtn,
      onPageChange: this.onPageChange,
      onSizePerPageList: this.onSizePerPageList,
      afterTableComplete: this.handleTableComplete,
      searchField: (props) => (
        <SearchBox keywords={this.keywords} sendSearchEvent={true} {...props} />
      ),
      afterSearch: this.afterSearch
    };

    const selectRow = {
      mode: 'checkbox',
      selected: selectedRows.map((row) => row.id),
      onSelect: this.onSelectRow,
      onSelectAll: this.onSelectAll
    };

    table = (
      <BootstrapTable
        selectRow={selectRow}
        data={this.props.usersStore.users}
        exportCSV
        search
        striped
        hover
        pagination
        options={tableOptions}
        csvFileName="users.csv"
        tableContainerClass={classNames(styles.tableContainerWrapper)}
        bodyContainerClass={classNames(styles.tableBodyWrapper)}
        headerContainerClass={classNames(styles.gridHeader)}
        trClassName="table-row"
      >
        <TableHeaderColumn
          ref="userStatusCol"
          dataField="active"
          className="table-header custom-filter-header"
          dataFormat={formatUserStatus}
          filterValue={this.getUserStatusFilterValue}
          filter={{
            type: 'CustomFilter',
            getElement: this.createUserStatusFilter
          }}
          csvFormat={this.formatCSV}
          width={`${this.state.columnWidths[1]}px`}
        >
          {this.t('STATUS')}
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="fullName"
          className="table-header"
          ref="nameCol"
          dataFormat={formatFullName}
          csvHeader={this.t('NAME')}
          csvFormat={this.formatCSV}
          dataSort
          width={`${this.state.columnWidths[2]}px`}
        >
          {this.t('NAME')}
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="userName"
          className="table-header"
          csvHeader={this.t('USER_NAME')}
          dataFormat={formatGeneric}
          csvFormat={this.formatCSV}
          dataSort
          width={`${this.state.columnWidths[3]}px`}
        >
          {this.t('USER_NAME')}
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="authenticationProvider"
          className="table-header"
          csvHeader={this.t('AUTHENTICATION_PROVIDER')}
          dataFormat={formatGeneric}
          csvFormat={this.formatCSV}
          dataSort
          width={`${this.state.columnWidths[4]}px`}
        >
          {this.t('AUTHENTICATION_PROVIDER')}
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="email"
          className="table-header"
          dataFormat={formatGeneric}
          csvHeader={this.t('EMAIL')}
          csvFormat={this.formatCSV}
          dataSort
          width={`${this.state.columnWidths[5]}px`}
        >
          {this.t('EMAIL')}
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="teamIds"
          className="table-header custom-filter-header"
          ref="teamsCol"
          filter={{ type: 'CustomFilter', getElement: this.createTeamFilter }}
          filterValue={this.getTeamsFilterValue}
          dataFormat={this.formatTeams}
          csvHeader={this.t('TEAMS')}
          csvFormat={this.formatCSVTeamName}
          width={`${this.state.columnWidths[6]}px`}
        >
          {this.t('TEAMS')}
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="teamIds"
          className="table-header custom-filter-header"
          ref="teamsCol"
          filterValue={this.getTeamsFilterValue}
          filter={{ type: 'CustomFilter', getElement: this.createTeamFilter }}
          dataFormat={this.formatTeamIds}
          csvHeader={this.t('TEAM_ID')}
          csvFormat={this.formatCSV}
          hidden={true}
          export={true}
          width={`${this.state.columnWidths[7]}px`}
        >
          {this.t('TEAM_ID')}
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="roleIds"
          className="table-header custom-filter-header"
          ref="rolesCol"
          filterValue={this.getRolesFilterValue}
          filter={{ type: 'CustomFilter', getElement: this.createRoleFilter }}
          dataFormat={this.formatRoles}
          csvHeader={this.t('ROLES')}
          csvFormat={this.formatCSVRoleName}
          width={`${this.state.columnWidths[8]}px`}
        >
          {this.t('ROLES')}
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="roleIds"
          className="table-header custom-filter-header"
          ref="rolesCol"
          filterValue={this.getRolesFilterValue}
          filter={{ type: 'CustomFilter', getElement: this.createRoleFilter }}
          dataFormat={this.formatRoleIds}
          csvHeader={this.t('ROLE_ID')}
          csvFormat={this.formatCSV}
          hidden={true}
          export={true}
          width={`${this.state.columnWidths[9]}px`}
        >
          {this.t('ROLE_ID')}
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="lastLoginDate"
          className="table-header custom-filter-header"
          ref="lastLoginDateCol"
          filterValue={this.getLastLoginFilterValue}
          filter={{
            type: 'CustomFilter',
            getElement: this.createLastLoginFilter
          }}
          dataFormat={this.formatDateHtml}
          csvHeader={this.t('LAST_LOGIN')}
          csvFormat={(dateTimeText) =>
            this.formatCSV(this.formatDateCsv(dateTimeText))
          }
          dataSort
          sortFunc={this.sortLastLoginDate}
          // width="145px"
          width={`${this.state.columnWidths[10]}px`}
        >
          {this.t('LAST_LOGIN')}
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="creationDate"
          className="table-header custom-filter-header"
          dataFormat={this.formatDateHtml}
          ref="creationDateCol"
          filterValue={this.getCreationDateFilterValue}
          filter={{
            type: 'CustomFilter',
            getElement: this.createCreationDateFilter
          }}
          csvHeader={this.t('CREATION_DATE')}
          csvFormat={(dateTimeText) =>
            this.formatCSV(this.formatDateCsv(dateTimeText))
          }
          dataSort
          sortFunc={this.sortCreationDate}
          // width="140px"
          width={`${this.state.columnWidths[11]}px`}
        >
          {this.t('CREATION_DATE')}
        </TableHeaderColumn>

        <TableHeaderColumn
          isKey
          dataField="id"
          className="table-header"
          dataFormat={formatRowMenu}
          csvFormat={this.formatCSV}
          csvHeader={this.t('USER_ID')}
          width="50px"
        ></TableHeaderColumn>
      </BootstrapTable>
    );

    return (
      <div>
        <div className="portal-grid">{table}</div>
      </div>
    );
  }
}
